var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyOptimized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 341,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.095 111.631h-22.087V95.468c0-11.028-8.972-20-20-20h-97.85c-11.028 0-20 8.972-20 20v16.163H86.072c-16.542 0-30 13.458-30 30V422.49c0 16.542 13.458 30 30 30h182.023c16.542 0 30-13.458 30-30V141.631c0-16.542-13.458-30-30-30zM86.072 422.49V141.631h182.023l.003 280.858z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.159 341.968h131.85v59.663h-131.85zM111.159 252.098h131.85v59.663h-131.85zM111.159 162.23h131.85v59.662h-131.85z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.337 45.711h-18.32V32.304c0-9.148-7.443-16.59-16.59-16.59h-81.168c-9.148 0-16.59 7.442-16.59 16.59v13.407H90.35c-13.722 0-24.885 11.164-24.885 24.886v232.972c0 13.722 11.163 24.885 24.885 24.885h150.988c13.722 0 24.885-11.163 24.885-24.885V70.597c0-13.722-11.163-24.886-24.885-24.886zM90.35 303.57V70.597h150.988l.002 232.972z",
    style: {
      fill: "#4dad33",
      fillOpacity: 1,
      strokeWidth: 0.829503
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4dad33",
      fillOpacity: 1,
      strokeWidth: 0.829503
    },
    d: "M111.159 236.777h109.37v49.491h-109.37zM111.159 162.229h109.37v49.491h-109.37z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyOptimized);
export default __webpack_public_path__ + "static/media/EnergyOptimized.8ac1b02d346e6b44c076922d8679ec24.svg";
export { ForwardRef as ReactComponent };